import React from 'react'
import classNames from 'classnames'
import PropTypes from 'prop-types'
import ParticleBackground from 'react-particle-backgrounds'
import { HiChevronRight } from 'react-icons/hi'
import { particleBackgroundSettingsButton } from 'configs/particle-background.config'
import { motion } from 'framer-motion'

const MenuItem = React.forwardRef((props, ref) => {
    const {
        asElement: Component,
        children,
        className,
        disabled,
        eventKey,
        isActive,
        menuItemHeight,
        onSelect,
        style,
        variant,
        ...rest
    } = props;

    const menuItemActiveClass = `menu-item-active`
    const menuItemHoverClass = `menu-item-hoverable`
    const disabledClass = 'menu-item-disabled'
    const menuItemClass = classNames(
        'menu-item',
        'relative',
        'overflow-hidden',
        `menu-item-${variant}`,
        isActive && menuItemActiveClass,
        disabled && disabledClass,
        !disabled && menuItemHoverClass,
        className
    )

    const hanldeOnClick = (e) => {
        if (onSelect) {
            onSelect(eventKey, e)
        }
    }

    return (
        <motion.div
            whileHover={!disabled && !isActive ? { 
                backgroundColor: variant === 'dark' ? 'rgba(255, 255, 255, 0.05)' : 'rgba(0, 0, 0, 0.02)',
                transition: { duration: 0.2 }
            } : {}}
            whileTap={!disabled ? { scale: 0.99 } : {}}
            className="w-full rounded-lg"
            style={{ backgroundColor: 'transparent' }}
        >
            <Component
                ref={ref}
                className={menuItemClass}
                style={{ height: `${menuItemHeight}px`, ...style }}
                onClick={hanldeOnClick}
                {...rest}
            >
                {isActive && <ParticleBackground settings={particleBackgroundSettingsButton} className="absolute w-[110%] ml-[-5%]" />}
                {children}
                {isActive && (
                    <motion.div
                        initial={{ x: -10, opacity: 0 }}
                        animate={{ x: 0, opacity: 1 }}
                        transition={{ type: "spring", stiffness: 300, damping: 20 }}
                    >
                        <HiChevronRight className='absolute text-xl top-1/2 -translate-y-1/2 right-3 hideCollapsed' />
                    </motion.div>
                )}
            </Component>
        </motion.div>
    )
})

MenuItem.defaultProps = {
    asElement: 'div',
    menuItemHeight: 40,
    variant: 'light',
}

MenuItem.propTypes = {
    asElement: PropTypes.string,
    menuItemHeight: PropTypes.number,
    disabled: PropTypes.bool,
    isActive: PropTypes.bool,
    eventKey: PropTypes.string,
    variant: PropTypes.oneOf(['light', 'dark', 'themed', 'transparent']),
}

export default MenuItem
